module.exports = __webpack_public_path__ + "es.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/es.svg
// module id = 537
// module chunks = 0